import React from 'react';

import { LeftConnectorApi } from '../hooks/useConnectors';
import { useAssignment } from '../hooks/useAssignment';
import QueryParams from '../utils/QueryParams';

interface Props {
    leftConnector: LeftConnectorApi;
    activeTab: string;
}

export default function AssignmentActionBar({ leftConnector, activeTab }: Props): JSX.Element {
    const devMode = QueryParams.devMode;
    const assignment = useAssignment();

    const handleSaveAndExit = () => {
        if (leftConnector.connectorType !== 'creo') {
            const missingPrimary = assignment.viewPartNrs.some(p => !p.bmId);
            if (missingPrimary) {
                leftConnector.toast.show('Cannot save: one or more primary parts do not have a Base Material assigned.', 0, 'error');
                return;
            }
        }
        leftConnector.sendAssignment(
            assignment.viewPartNrs,
            assignment.assignedMaterial,
            assignment.assignedTreatment,
            assignment.assignedCondition,
            assignment.assignedConditionType,
            assignment.alternateMaterials,
        );
        leftConnector.sendMTL?.();
        assignment.clearUnsavedChanges();
        window.close();
    };

    return (
        <>
            {leftConnector.connectorType !== 'creo' && (
                <button
                    className="btn"
                    onClick={leftConnector.assignMaterial}
                    disabled={activeTab !== 'iframe' || !assignment.hasTMMaterial}
                    style={{ marginTop: 16 }}
                >
                    Assign BaseMaterial
                </button>
            )}
            <button
                className="btn"
                onClick={() => leftConnector.assignAlternateMaterial()}
                disabled={activeTab !== 'iframe' || !assignment.hasTMMaterial || !assignment.assignedMaterial?.id}
                style={{ marginTop: leftConnector.connectorType === 'creo' ? 16 : 8 }}
            >
                Assign Alternate Base Material
            </button>
            <button
                className="btn"
                onClick={leftConnector.assignSurfaceTreatment}
                disabled={activeTab !== 'grid' || !assignment.hasTMSurface}
                style={{ marginTop: 8 }}
            >
                Assign SurfaceTreatment
            </button>
            
            <button
                className="btn color-affirmative"
                onClick={handleSaveAndExit}
                disabled={!assignment.hasUnsavedChanges}
                style={{ marginTop: 8 }}
            >
                Save &amp; Exit
            </button>
            
            {devMode && leftConnector.connectorType === 'abb' && (
                <button
                    className="btn color-affirmative"
                    onClick={() => leftConnector.sendAssignment(
                        assignment.viewPartNrs,
                        assignment.assignedMaterial,
                        assignment.assignedTreatment,
                        assignment.assignedCondition,
                        assignment.assignedConditionType,
                        assignment.alternateMaterials,
                    )}
                    style={{ marginTop: 8 }}
                >
                    DEV: send to windchill
                </button>
            )}

            {devMode === 'creo' && leftConnector.connectorType === 'creo' && (
                <button
                    className="btn color-affirmative"
                    onClick={leftConnector.sendMTL}
                    style={{ marginTop: 8 }}
                >
                    DEV: Mock MTL send
                </button>
            )}
        </>
    );
}
